import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../../assets/css/App.css';
import { max } from 'moment';
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class MifaIntro extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div className='Login-component'>
            <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['2']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub1" title={<span><Icon type="user" />Atlas</span>}>
                    <Menu.Item key="2"><Link to="/mifa-intro">Introduction</Link></Menu.Item>
                      <Menu.Item key="1"><Link to="/mifa-correlation">Correlation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                
                <div>
                            <Content style={{ marginLeft: 50, background: '#dcefef' }}>
                                <div style={{ marginLeft: 100, marginRight:100,paddingTop:30, width: 1000, height: 700, background: '#dcefef' }}>
                                <txt style={{fontSize:20,marginTop:50,}}>
                                <txt style={{fontSize:24,fontWeight:'bold'}}>Decoding medical imaging feature for human cancer</txt> 
                                </txt>
                            
                                <txt style={{fontSize:24,fontWeight:'bold',}}>
                                <br/><br/>
                                INSTRUCTIONS 
                                </txt>
                        
                                <txt style={{fontSize:20}}>
                                &nbsp;The medical image features atlas in this module is displayed in accordance with the parts of the human body. In the <txt style={{fontSize:20,fontWeight:'bold'}}>Correlation</txt> page, the correlation atlas on the left panel will display all the medical image features that are significantly associated with the clinical tasks of each type of cancer. Click on the cancer site (yellow node) or feature (blue node) which you are interested in and a detailed tree map of it will be displayed on the right panel. Based on the results of our review, the number of each node on the tree map is the frequency of the relationship reported in previous literatures. You can drag and zoom on the tree map by mouse wheel. Staying the mouse on the node will display the details of the it (such as image modality, role in assisting clinical diagnosis/prognosis, etc.).
                                <br/><br/><txt style={{fontSize:24,fontWeight:'bold'}}>Note </txt> In order to display the relationship between medical imaging features and human cancers, we reviewed the original name of all the features appeared in the previous literatures and constructed a meta-feature set which can represent all the original imaging features to ensure accurate and reliable statistical results. For example, the feature of 'skewness of the intensity gradient' will be mapped to three meta-features of skewness, intensity and gradient.
                                <br/><br/><txt style={{fontSize:24,fontWeight:'bold'}}>Please wait a few seconds if the correlation atlas loads slowly. </txt>
                                    </txt>
   
                                </div>
                            </Content>
                        </div>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default MifaIntro;